import { Box, Divider } from '@factorialco/deprecated-design-system'
import { F0Button, F0Select } from '@factorialco/f0-react'
import { Delete } from '@factorialco/f0-react/icons/app'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { track } from 'modules/core/lib/Tracking'
import { trackingEvents } from 'modules/core/lib/Tracking/events'
import i18n from 'modules/core/lib/i18n'

import { locale } from 'modules/marketplace_modules/components/utils/locales'
import { useGetProductUpdateModules } from 'modules/product_updates/hooks/useGetProductUpdateModules'

type Props = {
  selectedModule: string | undefined
  setSelectedModule: (module: string | undefined) => void
  onModuleChange: (e: string | undefined) => void
  isLaunched: boolean
  setIsLaunched: (isLaunched: boolean) => void
  canSeeSubscribeButton: boolean
  canSeeUpsellButton: boolean
  canSeeShareButton: boolean
  upsellOrigin: string | null
}

const ModuleFilters = ({
  selectedModule,
  onModuleChange,
  isLaunched,
  setIsLaunched,
  canSeeSubscribeButton,
  canSeeUpsellButton,
  canSeeShareButton,
  upsellOrigin,
}: Props) => {
  const session = useCurrentSession()
  const datoFormatLocale = locale[session.access.locale]
  const { modules } = useGetProductUpdateModules({ locale: datoFormatLocale })

  const options = [
    ...(modules?.map((productModule) => ({
      label: productModule.name,
      value: productModule.urlIdentifier,
    })) || []),
  ]

  const handleTabChange = (launched: boolean) => {
    setIsLaunched(launched)

    track(trackingEvents.productUpdates.visitProductUpdatesPage, {
      upsell_origin: upsellOrigin,
      allowed_to_see_subscribe_button: canSeeSubscribeButton,
      allowed_to_see_upsell_button: canSeeUpsellButton,
      allowed_to_see_share_button: canSeeShareButton,
      tab: launched ? 'launched' : 'coming_soon',
    })
  }
  return (
    <Box width="s600" flexDirection="row" gap="s12" id="module-filters">
      <F0Button
        size="lg"
        label={i18n.t('product_updates.tabs.launched')}
        variant={isLaunched ? 'neutral' : 'outline'}
        onClick={() => handleTabChange(true)}
      />
      <F0Button
        size="lg"
        label={i18n.t('product_updates.tabs.coming_soon')}
        variant={isLaunched ? 'outline' : 'neutral'}
        onClick={() => handleTabChange(false)}
      />
      <Divider vertical />
      <Box style={{ width: 'inherit' }}>
        <F0Select
          placeholder={i18n.t('product_updates.filters.all')}
          label={i18n.t('product_updates.filters.all')}
          hideLabel
          size="md"
          options={options}
          onChange={onModuleChange}
          value={selectedModule || ''}
        />
      </Box>

      {selectedModule && (
        <F0Button
          label=""
          hideLabel
          icon={Delete}
          onClick={() => {
            onModuleChange(undefined)
          }}
          round
          size="lg"
          variant="outline"
        />
      )}
    </Box>
  )
}

export default ModuleFilters
